var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7999 0.400024C6.35808 0.400024 5.9999 0.758197 5.9999 1.20002C5.9999 1.64185 6.35808 2.00002 6.7999 2.00002L8.86853 2.00002L3.83422 7.03434C3.5218 7.34676 3.5218 7.85329 3.83422 8.16571C4.14664 8.47813 4.65317 8.47813 4.96559 8.16571L9.9999 3.1314V5.20002C9.9999 5.64185 10.3581 6.00002 10.7999 6.00002C11.2417 6.00002 11.5999 5.64185 11.5999 5.20002V1.20002C11.5999 0.758197 11.2417 0.400024 10.7999 0.400024L6.7999 0.400024Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9999 2.00002C1.11625 2.00002 0.399902 2.71637 0.399902 3.60002L0.399902 10C0.399902 10.8837 1.11625 11.6 1.9999 11.6H8.3999C9.28356 11.6 9.9999 10.8837 9.9999 10L9.9999 7.60003C9.9999 7.1582 9.64173 6.80002 9.1999 6.80002C8.75807 6.80002 8.3999 7.1582 8.3999 7.60003L8.3999 10H1.9999L1.9999 3.60002L4.3999 3.60002C4.84173 3.60002 5.1999 3.24185 5.1999 2.80002C5.1999 2.3582 4.84173 2.00002 4.3999 2.00002L1.9999 2.00002Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxUpArrow);
export default __webpack_public_path__ + "static/media/BoxUpArrow.a8b0e9dd07b9386576f161e4de461608.svg";
export { ForwardRef as ReactComponent };